export default __webpack_public_path__ + "static/media/Logo-alpha-layer-cropped.5642d268.png";